import { IconButton, Tooltip } from "@mui/material";
import Icon from "@mdi/react";
import { mdiAlertCircleOutline, mdiSquareEditOutline, mdiTrashCanOutline } from "@mdi/js";
import { ICountEntry, ICountEntryTableProps } from "../../../../interfaces";
import styles from "./addCountDialog.module.scss";
import { CustomTooltip } from "../../../../components";
import { AdminExceptionHelper } from "../../../../utils";
import ResolveExceptionDialog from "../../../Exception/ResolveException/ResolveExceptionDialog";
import { useState } from "react";
import { ContainerType } from "../../../../utils/Enum/InventoryExceptionType";

const CountEntryTable: React.FC<ICountEntryTableProps> = ({
  entries,
  isPalletized,
  isCartoned,
  isLotted,
  isSerialized,
  onEdit,
  onDelete,
  isDeletable,
  isAllowSubmit,
  editRestrictionMessage,
  isCounter,
  isOnClickResolveException,
  onClose,
  onSubmit,
  isLocked,
  isEditOnContainerId
}) => {
  const [isResolveExceptionOpen, setIsResolveExceptionOpen] = useState(false);
  const [selectedDetailId, setSelectedDetailId] = useState<number | null>(null);
const [selectedTagId, setSelectedTagId] = useState<number | null>(null);
const [selectedContainerType, setSelectedContainerType] = useState<ContainerType | null>(null);
const [selectedValue, setSelectedValue] = useState<string | null>(null);

  if (entries.length === 0) return null;

const mergeExceptions = (exceptions?: string | null, localExceptions?: string | null): string => {
   return [exceptions, localExceptions].filter(e => e).join(',');
};

const adminExceptions = (text: string, isSerial: boolean,isLot:boolean, isCarton:boolean, isPallet:boolean, containerType: ContainerType, hasUnacceptedException?:boolean, id?: number, tagId?:number, value?:string, isForceRedIcon?:boolean) => {
  const handleResolveExceptionClick=(id:number|undefined, tagId:number|undefined, containerType:ContainerType, value:string|undefined, hasUnacceptedException: boolean|undefined)=>{
    if(hasUnacceptedException && !isLocked){
      setSelectedDetailId(id ?? null);
      setSelectedTagId(tagId ?? null);
      setSelectedContainerType(containerType);
      setIsResolveExceptionOpen(true);
      setSelectedValue(value ?? null);
    }
  }
  const ae = AdminExceptionHelper.adminException({exceptions: text, isSpecific: true,isSerial:isSerial, isLot:isLot, isCarton:isCarton, isPallet:isPallet, unacceptedExceptions:null});
  return(ae.isException && (
    <CustomTooltip title={ae.tooltipTitle} tooltipMessage={ae.tooltipMessage}  onClick={() => {handleResolveExceptionClick(id, tagId, containerType, value, hasUnacceptedException);}}>
      <IconButton className={styles.exceptionIcon} sx={{ p: 0 }}>
        <Icon path={mdiAlertCircleOutline} size={1} color={isForceRedIcon || hasUnacceptedException? "red" : "grey"} />
      </IconButton>
    </CustomTooltip>
  ));
}
  return (
    <div className={styles.tableWrapper}>
    <table className={styles.countTable}>
      <thead>
        <tr>
          {isPalletized && <th className={styles.countTable_th}>Pallet No.</th>}
          {isCartoned && <th className={styles.countTable_th}>Carton No.</th>}
          {isLotted && <th className={styles.countTable_th}>Lot ID</th>}
          {isSerialized && <th className={styles.countTable_th}>Serial No.</th>}
          {!isSerialized && <th className={styles.countTable_th}>Qty</th>}
          <th className={`${styles.countTable_th} ${styles.countTable_actions}`}>Action</th>
        </tr>
      </thead>
      <tbody className={styles.scrollable_tbody}>
        {entries.map((entry: ICountEntry, index: number) => (
          <tr key={index}>
            {isPalletized && (
              <td className={styles.countTable_td}>
                <div className={styles.cellContent}>
                            <Tooltip title={<span className={styles.truncatedText}>{entry.pallet}</span>}><span className={styles.truncatedText}>{entry.pallet}&nbsp;</span></Tooltip>
                            {
                            adminExceptions(
                              mergeExceptions(entry.otherTagExceptions, entry.localExceptions)
                              , false
                              , false
                              , false
                              , true
                              , ContainerType.Pallet
                              , entry.hasUnacceptedPalletException 
                                || entry.id == null 
                                || entry.pallet?.toLowerCase().trim() !== entry.storedPallet?.toLowerCase().trim()
                              , entry.id
                              , entry.tagId
                              , entry.pallet
                              , entry.isForceRedIconPallet)}
                </div>
              </td>
            )}
            {isCartoned && (
              <td className={styles.countTable_td}>
                <div className={styles.cellContent}>
                            <Tooltip title={<span className={styles.truncatedText}>{entry.carton}</span>}><span className={styles.truncatedText}>{entry.carton}&nbsp;</span></Tooltip>{adminExceptions(mergeExceptions(entry.otherTagExceptions, entry.localExceptions), false, false, true, false, ContainerType.Carton, entry.hasUnacceptedCartonException || entry.id == null || entry.carton?.toLowerCase().trim() !== entry.storedCarton?.toLowerCase().trim(), entry.id, entry.tagId, entry.carton, entry.isForceRedIconCarton)}
                </div>
              </td>
            )}
            {isLotted && (
              <td className={styles.countTable_td}>
                <div className={styles.cellContent}>
                            <Tooltip title={<span className={styles.truncatedText}>{entry.lot}</span>}><span className={styles.truncatedText}>{entry.lot}&nbsp;</span></Tooltip>{adminExceptions(mergeExceptions(entry.otherTagExceptions, entry.localExceptions), false, true, false, false, ContainerType.Lot, entry.hasUnacceptedLotException || entry.id == null|| entry.lot?.toLowerCase().trim() !== entry.storedLot?.toLowerCase().trim(), entry.id, entry.tagId, entry.lot, entry.isForceRedIconLot)}
                </div>
              </td>
            )}
            {isSerialized && (
             <td className={styles.countTable_td}>
                <div className={styles.cellContent}>
                          <Tooltip title={<span className={styles.truncatedText}>{entry.serialNo}</span>}><span className={styles.truncatedText}>{entry.serialNo}&nbsp;</span></Tooltip>
                            {adminExceptions(mergeExceptions(entry.otherTagExceptions, entry.localExceptions), true, false, false, false, ContainerType.SerialNo, entry.hasUnacceptedSerialException || entry.id == null || entry.serialNo?.toLowerCase().trim() !== entry.storedSerialNo?.toLowerCase().trim(), entry.id, entry.tagId, entry.serialNo, entry.isForceRedIconSerialNo)}
                </div>
              </td>
            )}
            {!isSerialized && <td className={styles.countTable_td}>{entry.qty}</td>}
            <td className={`${styles.countTable_td} ${styles.countTable_actions}`}>
              <Tooltip title={isAllowSubmit ? "Edit" : editRestrictionMessage}>
                <span>
                  <IconButton onClick={() => onEdit(isEditOnContainerId && entry?.id ? entry.id : index)} disabled={!isAllowSubmit} tabIndex={-1}>
                    <Icon path={mdiSquareEditOutline} size={0.8}/>
                  </IconButton>
                </span>
              </Tooltip>
              {isDeletable && (
              <Tooltip title="Delete">
                <span>
                  <IconButton onClick={() => onDelete(index)} tabIndex={-1}>
                    <Icon path={mdiTrashCanOutline} size={0.8} />
                  </IconButton>
                </span>
              </Tooltip>)}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  {isOnClickResolveException && isResolveExceptionOpen && selectedDetailId !== null && selectedTagId !== null && selectedContainerType !== null && (
  <ResolveExceptionDialog
    open={isResolveExceptionOpen}
    onClose={() => setIsResolveExceptionOpen(false)}
    onSubmit={() => {
      setIsResolveExceptionOpen(false);
      if (onSubmit) onSubmit();
    }
    }
    containarizeDetailId={selectedDetailId}
    tagId={selectedTagId}
    containerType={selectedContainerType}
    selectedValue={selectedValue}
  />
)}
   </div>
  );
};

export default CountEntryTable;
